/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_RefusedInputs */



/**
* | output |
* | --- |
* | "The provider's answer could not be accepted. Use the email link instead." |
*
* @param {Portal_X13_Error_RefusedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_refused = /** @type {((inputs?: Portal_X13_Error_RefusedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_RefusedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("The provider's answer could not be accepted. Use the email link instead.")
});